import { useEffect, useState } from 'react';
import { supabase } from './lib/supabase';

type Context={organizationId:string;purpose:string;passportId:string;asset:{vesselId:string;vesselCode:string;vesselName?:string|null;year?:number|null;make:string;model:string;hin?:string|null;location?:string|null;portEngineHours?:number|null;starboardEngineHours?:number|null}};

export default function BamsNfcBridge(){
  const params=new URLSearchParams(window.location.search);
  const purpose=String(params.get('bams')||'').toLowerCase();
  const token=String(params.get('tag')||'');
  const active=['service','inspection'].includes(purpose)&&token.length>=20;
  const [state,setState]=useState<{status:string;context:Context|null;error:string}>({status:active?'checking':'idle',context:null,error:''});

  useEffect(()=>{
    if(!active||!supabase)return;
    let alive=true;
    const resolve=async()=>{
      const session=await supabase.auth.getSession();
      if(!alive)return;
      if(!session.data.session){setState({status:'signin',context:null,error:''});return;}
      const result=await supabase.rpc('marine_bams_tag_context',{check_token:token,check_expected_purpose:purpose});
      if(!alive)return;
      if(result.error){setState({status:'error',context:null,error:result.error.message});return;}
      setState({status:'ready',context:result.data as Context,error:''});
    };
    void resolve();
    const {data}=supabase.auth.onAuthStateChange(()=>void resolve());
    return()=>{alive=false;data.subscription.unsubscribe();};
  },[active,purpose,token]);

  if(!active||state.status==='idle'||state.status==='signin')return null;
  const ctx=state.context,vessel=ctx?.asset;
  const clear=()=>{const u=new URL(window.location.href);u.searchParams.delete('bams');u.searchParams.delete('tag');window.history.replaceState(null,'',u.pathname+(u.search||'')+u.hash);};
  const open=()=>{
    if(ctx)sessionStorage.setItem('blackbird-bams-context',JSON.stringify({product:'marineops',purpose,passportId:ctx.passportId,organizationId:ctx.organizationId,asset:ctx.asset,openedAt:new Date().toISOString()}));
    clear();
    window.dispatchEvent(new CustomEvent('blackbird:bams-open',{detail:ctx}));
    setState({status:'idle',context:null,error:''});
  };

  return <div className="marineBamsOverlay"><section className="marineBamsCard" role="dialog" aria-modal="true">
    <span>BAMS · {purpose.toUpperCase()}</span>
    {state.status==='checking'?<><h2>Reading vessel tag…</h2><p>MarineOps is verifying the tag and your organization access.</p></>:null}
    {state.status==='error'?<><h2>Tag unavailable</h2><p>{state.error}</p><button onClick={()=>{clear();setState({status:'idle',context:null,error:''});}}>Close</button></>:null}
    {state.status==='ready'?<>
      <h2>{vessel?.vesselName||vessel?.vesselCode||'MarineOps vessel'}</h2>
      <p>{[vessel?.year,vessel?.make,vessel?.model,vessel?.location].filter(Boolean).join(' · ')}</p>
      <div className="marineBamsMeta">
        <span><small>Function</small><strong>{purpose==='service'?'Service / maintenance':'Inspection / condition'}</strong></span>
        <span><small>Asset Passport</small><strong>{ctx?.passportId||'—'}</strong></span>
        <span><small>HIN</small><strong>{vessel?.hin||'—'}</strong></span>
        <span><small>Engine hours</small><strong>{vessel?.portEngineHours!=null?Number(vessel.portEngineHours).toLocaleString()+' h':'—'}</strong></span>
      </div>
      <button className="marineBamsPrimary" onClick={open}>Continue in MarineOps</button>
      <small className="marineBamsNote">This tag is purpose-bound and resolves only to this vessel/workflow.</small>
    </>:null}
  </section></div>;
}
